type Props = {
  value?: string | null
  className?: string
}

const ENERGY_COLORS: Record<string, string> = {
  'A+++': '#009640',
  'A++': '#35a931',
  'A+': '#61b84a',
  A: '#89c547',
  B: '#b6cf3e',
  C: '#e0c63a',
  D: '#f2a93b',
  E: '#ea7c32',
  F: '#db592b',
  G: '#c73e2f',
}

const normalizeEnergyClass = (value: string) => value.trim().toUpperCase().replace(/\s+/g, '')

const EnergyClassBadge = ({ value, className = '' }: Props) => {
  const normalized = value ? normalizeEnergyClass(value) : ''
  if (!normalized) {
    return <span className={`text-sm text-slate-600 ${className}`}>-</span>
  }
  const bgColor = ENERGY_COLORS[normalized] ?? '#64748b'

  return (
    <span className={`inline-flex items-center gap-1 ${className}`} aria-label={`Classe energetica ${normalized}`}>
      <span className="inline-flex items-center justify-center rounded-sm bg-slate-900 px-1.5 py-1 text-[10px] font-bold leading-none text-white">
        UE
      </span>
      <span
        className="inline-flex items-center px-2 py-1 text-xs font-bold leading-none text-white shadow-sm"
        style={{
          backgroundColor: bgColor,
          clipPath: 'polygon(0 0, calc(100% - 11px) 0, 100% 50%, calc(100% - 11px) 100%, 0 100%)',
          paddingRight: '17px',
        }}
      >
        {normalized}
      </span>
    </span>
  )
}

export default EnergyClassBadge
